<template src="./Index.html">
</template>

<script>
import AddView from './actions/Add.vue';
import EditView from "./actions/Edit.vue";
import DetailsView from "./actions/Details.vue";

export default {
  components: {
    AddView,
    EditView,
    DetailsView,
  },
  created() {
    this.getAll();
    this.$store.dispatch("lookups/getDoctors");
  },
  computed: {
    pageCount() {
      return Math.ceil(
        this.$store.state.doctorPrescriptions.totalItems / this.filters.pageSize
      );
    },
    doctorPrescriptions() {
      return this.$store.state.doctorPrescriptions.doctorPrescriptions;
    },
    doctors() {
      return [
        ...this.$store.state.lookups.doctors];
    },
    user() {
      return this.$store.state.security.user;
    },
  },
  data() {
    return {
      permissions: this.$patientsManagementPermissions.doctorPrescriptionsPermissions,
      view: 0,
      dialog: false,
      dialogType: null,
      dialogMessage: "",
      filters: {
        page: 1,
        pageSize: 10,
        doctorId: null,
        fullName: null,
        phoneNo: null,
        orderNo: null,
      },
      headers: [
        { text: 'رقم الطلب ', value: 'orderNo' },
        { text: "اسم الحالة", value: 'fullName' },
        { text: "اسم الطبيب", value: 'doctorName' },
        { text: "تاريخ الموعد", value: "appointmentDate", sortable: false },
        { text: "حالة الطلب ", value: "status", sortable: false },
        { text: "مسجل بواسطة", value: "createdBy", sortable: false },
        { text: "تاريخ التسجيل", value: "createdOn", sortable: false },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],

      itemId: 0,
    };
  },
  methods: {
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("doctorPrescriptions/getAll", this.filters);
    },

    addItem() {
      this.view = 1;
    },
    viewItem(item) {
      this.itemId = item.id;
      this.view = 3;
      // Implement view logic
    },
    editItem(item) {
      this.itemId = item.id;
      this.view = 2;
      // Implement edit logic
    },
    showDialog(item, type) {
      switch (type) {
        // case "delete":
        //   this.dialogMessage = "هل انت متأكد من رغبتك حذف البيانات";
        //   break;
        // case "approval":
        //   this.dialogMessage = "هل انت متأكد من رغبتك اعتماد البيانات";
        //   break;
        case "cancel":
          this.dialogMessage = "هل انت متأكد من رغبتك الغاء العملية";
          break;
      }
      this.dialogType = type;
      this.itemId = item.id;
      this.dialog = true;
    },
    handleClear() {
      this.filters.transferDate = null;
    },
    confirmDialog() {
      this.$store.dispatch(`doctorPrescriptions/${this.dialogType}`, { id: this.itemId, doctorId: this.filters.doctorId });
      this.cancelDialog();
    },

    cancelDialog() {
      this.dialog = false;
      this.itemId = 0;
      this.dialogMessage = "";
      this.dialogType = null;
    },
    back() {
      this.view = 0;
      this.getAll()
    },
     print(item) {
      this.itemId = item.id;
      const routeData = this.$router.resolve(
        `/prescription-print/${this.itemId}`
      );
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style scoped></style>